import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button as MuiButton,
  IconButton,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import WarningIcon from "@mui/icons-material/Warning";
import CloseIcon from "@mui/icons-material/Close";
import TextView from "../../../../TextView";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  ".MuiBackdrop-root": {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
  },
  ".MuiPaper-root": {
    padding: "15px 8px",
    border: "1px solid #E1E1E1",
    borderRadius: 8,
  },
}));

const ConfirmationModal = ({
  isOpen,
  handleClose,
  onConfirm,
  title = "Confirmation",
  message,
  icon = <WarningIcon color="warning" />,
  confirmText = "Yes, Proceed",
  cancelText = "Cancel",
  confirmButtonColor = "#9B5AF8",
  showIcon = true,
  width = "auto",
}) => {
  const handleCancel = () => {
    handleClose();
  };

  const handleConfirm = () => {
    onConfirm();
    handleClose();
  };

  return (
    <StyledDialog
      open={isOpen}
      onClose={handleCancel}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{ width: width }}
    >
      <DialogTitle
        sx={{ borderBottom: "1px solid #E1E1E1", marginBottom: "10px" }}
      >
        <TextView variant="title">
          {showIcon && (
            <Box
              component="span"
              sx={{
                marginRight: "10px",
                display: "inline-flex",
                verticalAlign: "middle",
              }}
            >
              {icon}
            </Box>
          )}
          {title}
        </TextView>
        <IconButton
          aria-label="close"
          onClick={handleCancel}
          sx={{
            position: "absolute",
            right: 8,
            top: 30,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextView variant="subtitle">{message}</TextView>
      </DialogContent>
      <DialogActions>
        <MuiButton
          variant="text"
          onClick={handleCancel}
          sx={{ color: "black", textTransform: "capitalize" }}
        >
          <TextView variant="subtitle">{cancelText}</TextView>
        </MuiButton>
        <MuiButton
          variant="outlined"
          onClick={handleConfirm}
          sx={{
            backgroundColor: confirmButtonColor,
            color: "white",
            textTransform: "capitalize",
            "&:hover": {
              backgroundColor: confirmButtonColor,
            },
          }}
        >
          {confirmText}
        </MuiButton>
      </DialogActions>
    </StyledDialog>
  );
};

export default ConfirmationModal;
